/* eslint-disable jsx-a11y/media-has-caption */
'use client'

import { transformToMarkdownLetter } from '@/components/utils/MarkdownWithoutExtension'
import { SystemMessageDetail } from '@/types/letter'
import { isVideoUrl } from '@/utils/img'

type LetterDetailContentProps = {
  detail?: SystemMessageDetail
}

type LetterDetailMedia = {
  type: 'image' | 'video'
  url: string
}

const getLetterDetailMedia = (
  detail?: Pick<SystemMessageDetail, 'image' | 'video' | 'video_urls'>
): LetterDetailMedia[] => {
  if (!detail) return []

  const seen = new Set<string>()
  const result: LetterDetailMedia[] = []

  const appendMedia = (url: string, type: LetterDetailMedia['type']) => {
    if (!url || seen.has(url)) {
      return
    }

    seen.add(url)
    result.push({ type, url })
  }

  ;(detail.video_urls || []).forEach((url) => appendMedia(url, 'video'))
  ;(detail.image || []).forEach((url) =>
    appendMedia(url, isVideoUrl(url) ? 'video' : 'image')
  )

  return result
}

export default function LetterDetailContent({
  detail,
}: LetterDetailContentProps) {
  const mediaList = getLetterDetailMedia(detail)

  return (
    <>
      <div className="mb-3 w-full break-all px-5 text-base font-bold text-white">
        {detail?.title}
      </div>
      {mediaList.length > 0 && (
        <div className="space-y-3 px-5">
          {mediaList.map((media, index) => (
            <div
              key={`${media.type}-${media.url}-${index}`}
              className="overflow-hidden rounded-2xl bg-black/20"
            >
              {media.type === 'video' ? (
                <video
                  src={media.url}
                  controls
                  playsInline
                  preload="metadata"
                  className="max-h-[70vh] w-full bg-black object-contain"
                />
              ) : (
                <img
                  src={media.url}
                  alt=""
                  className="max-h-[70vh] w-full bg-black object-contain"
                />
              )}
            </div>
          ))}
        </div>
      )}
      <div
        className="prose !prose-invert px-5 py-5"
        dangerouslySetInnerHTML={{
          __html: transformToMarkdownLetter(detail?.content || ''),
        }}
      />
    </>
  )
}
